import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { lastValueFrom } from 'rxjs';
import { UserService } from '../services/Modules/user.service';
import { AuthService } from '../services/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-all-users-list',
  templateUrl: './all-users-list.component.html',
  styleUrls: ['./all-users-list.component.css']
})
export class AllUsersListComponent implements OnInit {
  dataSource: any = new MatTableDataSource([]);
  displayedColumns: string[] = ['first_name', 'last_name', 'email', 'user_type', 'company_name'];
  searchUser: any;
  allUsers: [];
  pagination = {
    currentPage: 1,
    totalRecords: 0,
    pageLimit: 50
  }
  loaderId = 'all-user-list-loader';

  constructor(
    private userService: UserService,
    private _authService: AuthService,
    private loader: NgxUiLoaderService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.getAllUsers();
  }

  goToPreviousPage() {
    if (this.pagination.currentPage > 1) {
      this.pagination.currentPage--;
      this.getAllUsers();
    }
  }

  goToNextPage() {
    if (this.pagination.currentPage < this.getTotalPages()) {
      this.pagination.currentPage++;
      this.getAllUsers();
    }
  }

  getTotalPages() {
    return Math.ceil(this.pagination.totalRecords / this.pagination.pageLimit);
  }

  getStartIndex() {
    return (this.pagination.currentPage - 1) * this.pagination.pageLimit + 1;
  }

  getEndIndex() {
    const endIndex = this.pagination.currentPage * this.pagination.pageLimit;
    return endIndex > this.pagination.totalRecords ? this.pagination.totalRecords : endIndex;
  }

  searchUsers(event) {
    this.searchUser = event;
    this.getAllUsers();
  }
  async getAllUsers() {
    this.loader.startLoader(this.loaderId);
    const filter = {
      is_activated: 'true',
      SearchValue: this.searchUser,
      key: 'last_name'
    };
    if (!this.searchUser) {
      delete filter.SearchValue;
      delete filter.key
    }
    const projection = {
      'first_name': 1,
      'last_name': 1,
      'title': 1,
      'full_name': 1,
      'email': 1,
      'user_type': 1
    }
    const populate = { company_id: 'name' }
    if (this.pagination.currentPage < 1) {
      this.pagination.currentPage = 1;
    }
    const skip = (this.pagination.currentPage - 1) * this.pagination.pageLimit
    const PAGE_LIMIT = this.pagination.pageLimit
    try {
      const response = await lastValueFrom(this.userService.getUsers(filter, projection, populate, skip, PAGE_LIMIT,true));
      if (response["status"] === 200) {
        this.allUsers = response["data"]["users"];
        this.dataSource.data = this.allUsers;
        this.pagination.totalRecords = response["data"]["totalRecords"];
        if (this.pagination.totalRecords === 0) {
          this.pagination.currentPage = 0;
          this.toastr.info("No Records Found","INFORMATION");
        } else if (this.pagination.currentPage > this.getTotalPages()) {
          this.pagination.currentPage = this.getTotalPages();
        }

        this.loader.stopLoader(this.loaderId);
      } else {
        this.toastr.error(response["message"], "ERROR");
      }

    } catch (error) {
      this.toastr.error(error["message"], "ERROR");
    }
  }
  isNoRecords(): boolean {
    return this.pagination.totalRecords === 0;
  }

}
